import React from "react";

import { FooterStyles } from "./FooterStyles";
import { footerKeys, footerData } from "./FooterContent";
import { useTheme } from "../../../providers/ThemeContext";
import { useI18n } from "../../../languages/providers/I18nProvider";
import SocialLinks from "../../common/SocialLinks";
import FooterBottomBar from "./FooterBottomBar";
import FooterAddress from "./FooterAddress";
import FooterContactInfo from "./FooterContactInfo";
import FooterServices from "./FooterServices";
import FooterHelp from "./FooterHelp";
import BrandWordmark from "../../brand/BrandWordmark";
import { useLangPath } from "../../../hooks/useLangPath";

const Footer = () => {
  const { theme } = useTheme();
  const { t } = useI18n();
  const lp = useLangPath();

  const s = FooterStyles(theme);
  const ft = theme.footerTheme;

  return (
    <footer style={s.root}>
      <div style={s.container}>
        <div style={s.grid}>
          <div style={s.brand}>
            <BrandWordmark height={70} width={"70%"} />
            <div style={s.tagline}>{t(footerKeys.tagline)}</div>
            <SocialLinks
              instagram={footerData.reach.socials.instagram}
              whatsapp={footerData.reach.socials.whatsapp}
              color={ft.text}
              size="small"
              gap={8}
            />
          </div>
          <FooterServices />
          <FooterHelp />
          <FooterAddress showMap />
          <FooterContactInfo showSocials={false} />
        </div>
        <FooterBottomBar />
      </div>
    </footer>
  );
};

export default Footer;
